
<h2 *ngIf="!adminUserId" class="headerTitle">{{'newsletter_unsubscribe_description' |  translate}}<div class="line"></div></h2>
<div [ngClass]="{'isUser': adminUserId}" *ngIf="!loading">
  <div *ngFor="let category of categories" class="field-checkbox">
    <p-checkbox name="group" [value]="category.id" [(ngModel)]="selectedCategories" [label]="category.name" [inputId]="category.id"></p-checkbox>
</div>
<div style="height: 10px;"></div>
<button (click)="onSubmit()" class="ui-button-info" [label]="'save' | translate"  pButton type="submit"></button>
</div>


<app-loader *ngIf="loading" [size]="30"></app-loader>
